import { typographyStyles } from '@app/components/core/typography/styles'
import { type Style } from 'inlines'

export const editorShellStyle = (hasError: boolean): Style => ({
  position: 'relative',
  isolation: 'isolate',
  borderRadius: '0.75rem',
  border: `1px solid ${hasError ? 'var(--brand-primary)' : 'var(--palette-blue-300)'}`,
  background: hasError ? 'var(--status-error-muted)' : 'var(--palette-white)',
  padding: '0.5rem',
  minHeight: '8rem',
  overflow: 'hidden',
  '& .LexicalRichHtmlInput-paragraph': {
    ...typographyStyles.medium,
  },
  '& .LexicalRichHtmlInput-textBold': { fontWeight: 700 },
  '& .LexicalRichHtmlInput-textItalic': { fontStyle: 'italic' },
  '& .LexicalRichHtmlInput-textStrikethrough': {
    textDecoration: 'line-through',
  },
  '& .LexicalRichHtmlInput-listUl, & .LexicalRichHtmlInput-listOl': {
    margin: '0.35rem 0',
    paddingLeft: '1.5rem',
  },
  '& .LexicalRichHtmlInput-listItem': {
    fontSize: '1.125rem',
    lineHeight: '1.75rem',
  },
  '& [contenteditable="true"]:focus': {
    outline: 'none',
  },
})

export const editorEditableStyle: Style = {
  outline: 'none',
  position: 'relative',
  zIndex: 1,
  minHeight: '6.5rem',
  paddingBottom: '2.5rem',
}
